import type { Ref } from 'vue'
import { watch } from 'vue'
// import { shadowBody } from '@/utils/build';
// import { usePinch, useHover } from '@vueuse/gesture';
// import { interpolate } from 'popmotion';
import { useMousePressed } from '@vueuse/core'
import { clearAllBodyScrollLocks, disableBodyScroll } from 'body-scroll-lock'
// import round from 'lodash/round'

export const useZoom = (containerRef: Ref<HTMLElement>, canvasRef: Ref<HTMLCanvasElement>) => {
  // const interacting = ref(false);
  // const zoomCurrent = ref(1);
  // const mapper = interpolate([-1000, 0, 1000], [1, 1.25, 2.5], { clamp: true });
  const { pressed } = useMousePressed({ target: canvasRef })

  watch(pressed, (value) => {
    if (value)
      disableBodyScroll(document.body)
    else
      clearAllBodyScrollLocks()

    // toggleEventDefault(value);
  })

  // const pinchHandler = ({ offset: [d, a] }) => {
  //   // ! it's means fire event smoothly on mobile [1, 1.5, 2]
  //   const value = round(mapper(d), 2)
  //   if (value === zoomCurrent.value) return
  //   if (value > zoomCurrent.value) {
  //     callback('zoomIn')
  //   } else {
  //     callback('zoomOut')
  //   }
  //   zoomCurrent.value = value
  // };
  // usePinch(pinchHandler, {
  //   domTarget: containerRef.value,
  //   eventOptions: {
  //     passive: true,
  //   },
  // });
  // ? Disable viewport pinch zoom on whole app
  // const cancelEvent = (e: Event) => e.preventDefault();

  // const toggleEventDefault = (onTouch = false) => {
  //   if (!onTouch) {
  //     window.removeEventListener('wheel', cancelEvent);
  //     document.removeEventListener('gesturestart', cancelEvent);
  //     document.removeEventListener('gesturechange', cancelEvent);
  //     interacting.value = false;
  //   } else {
  //     window.addEventListener('wheel', cancelEvent, {
  //       passive: false,
  //     });
  //     document.addEventListener('gesturestart', cancelEvent, { passive: false });
  //     document.addEventListener('gesturechange', cancelEvent, { passive: false });
  //     interacting.value = true;
  //   }
  // }

  // const hoverHandler = ({ hovering }) => {
  //   toggleEventDefault(hovering);
  // }

  // useHover(hoverHandler, {
  //   domTarget: containerRef.value,
  // });

  // watch(interacting, (newVal) => {
  //   if (newVal) {
  //     shadowBody().classList.add('interacting');
  //     shadowBody().classList.add('interacting');
  //     return;
  //   }
  //   shadowBody().classList.remove('interacting');
  //   shadowBody().classList.remove('interacting');
  // });

  return {
    // pinchHandler,
    // interacting,
    // hoverHandler,
    pressed,
  }
}
